export default "__VITE_ASSET__C3j5bX2i__"